export const DATA_SOURCE_DETAIL_HASH_PREFIX = "#/admin/data-source/";
export const DATA_SOURCE_LIST_HASH = "#/admin/real-estate-source-controls";

export function buildDataSourceDetailHash(domainId, sourceKey) {
  const domain = encodeURIComponent(String(domainId || "").trim());
  const key = encodeURIComponent(String(sourceKey || "").trim());
  if (!domain || !key) return DATA_SOURCE_LIST_HASH;
  return `${DATA_SOURCE_DETAIL_HASH_PREFIX}${domain}/${key}`;
}

export function buildDataSourceDetailHref(domainId, sourceKey) {
  return `/?perspective=administration&admin=data-ops/sources${buildDataSourceDetailHash(
    domainId,
    sourceKey
  )}`;
}

export function readDataSourceDetailFromHash(hash = "") {
  const normalized = hash || (typeof window !== "undefined" ? window.location.hash : "");
  if (!normalized.startsWith(DATA_SOURCE_DETAIL_HASH_PREFIX)) {
    return null;
  }

  const rest = normalized.slice(DATA_SOURCE_DETAIL_HASH_PREFIX.length).split("?")[0];
  const slash = rest.indexOf("/");
  if (slash <= 0) {
    return null;
  }

  const domainId = decodeURIComponent(rest.slice(0, slash)).trim();
  const sourceKey = decodeURIComponent(rest.slice(slash + 1)).trim();
  if (!domainId || !sourceKey) {
    return null;
  }

  return { domainId, sourceKey };
}

export function isAdministrationDataSourcesShell(search = "") {
  const params = new URLSearchParams(
    search || (typeof window !== "undefined" ? window.location.search : "")
  );
  return params.get("perspective") === "administration" && Boolean(params.get("admin"));
}

export function navigateToDataSourceDetail(domainId, sourceKey) {
  window.location.hash = buildDataSourceDetailHash(domainId, sourceKey);
}

export function navigateToDataSourceList() {
  if (isAdministrationDataSourcesShell()) {
    const nextUrl = `${window.location.pathname}${window.location.search}`;
    window.history.pushState({}, "", nextUrl);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
    return;
  }
  window.location.hash = DATA_SOURCE_LIST_HASH;
}
